const TXT = {

  name: `Name`,
  password: `Password`,
  find: `find...`,
  login: `Login`,
  logout: `Logout`,
  year: `2024`,
  myMsg: `You`,
  infoTittle: `Dear friend!`,
  infoDescription: `Welcome to Fun-Chat – a web application for chatting with friends. Here, you can share photos, send voice messages, and exchange memes. Whether you’re looking for lighthearted conversations or serious discussions, we’ve got a place for everyone. Let’s get started and create unforgettable moments together! 🎉📱👋`,
  message404: `Ups... 404 Page not found`,
  messageEmptyUser: `Chose user for dialog`,
  messageEmptyChat: `Start your dialog`,
  messageNewMessage: `New message`,
  messageBCError: `Child is not an instance of BaseComponent`,
  messageServerDisconnect: `Lost connection with server`,
}

export default TXT;
